import { talukaAddApi } from "../../api/taluka/talukaAddApi"

type PayloadShape = Parameters<typeof talukaAddApi>[0]

export async function talukaAddService(payload: PayloadShape, token: string) {
	return await talukaAddApi(payload, token)
}
